import { createFileRoute } from '@tanstack/react-router';
import { ShipmentDetail } from '@uturn/portal/modules/shipments';
import { ShipmentDetailSkeletonLoader } from '@uturn/portal/modules/shipments/components/shipment-details-skeleton';
import { ShipmentDetailProvider } from '@uturn/portal/modules/shipments/providers/shipment-detail';
import { Suspense } from 'react';
import z from 'zod';

const ShipmentsShipmentNumberParams = z.object({
	shipmentNumber: z.coerce.number(),
});

export const Route = createFileRoute('/_protected/shipments/$shipmentNumber')({
	params: {
		parse: (rawParams) => ShipmentsShipmentNumberParams.parse(rawParams),
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<Suspense fallback={<ShipmentDetailSkeletonLoader />}>
			<ShipmentDetailProvider>
				<ShipmentDetail />
			</ShipmentDetailProvider>
		</Suspense>
	);
}
